import { render, staticRenderFns } from "./PlanListPage.vue?vue&type=template&id=54d8f014&scoped=true&"
import script from "./PlanListPage.vue?vue&type=script&lang=js&"
export * from "./PlanListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8f014",
  null
  
)

export default component.exports